// Generated by ReScript, PLEASE EDIT WITH CARE


function MakeEncodable(M) {
  var encode = M.encode;
  var encode$1 = function (x) {
    return encode(x);
  };
  var decode = M.decode;
  var decode$1 = function (x) {
    return decode(x);
  };
  return {
          encode: encode$1,
          decode: decode$1
        };
}

export {
  MakeEncodable ,
}
/* No side effect */
